import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  HiOutlineGlobeAlt,
  HiOutlineDocumentText,
  HiOutlineSparkles,
} from "react-icons/hi2";
import AddSongModal from "../Songs/AddSongModal";
import CifraImportPanel from "../../../components/CifraImportPanel";
import { CifraImportPrefill } from "../../../utils/cifraApi";

const Cifra: React.FC = () => {
  const { t } = useTranslation();
  const [showAddModal, setShowAddModal] = useState(false);
  const [addPrefill, setAddPrefill] = useState<CifraImportPrefill | null>(null);
  const [importError, setImportError] = useState("");

  return (
    <div className="max-w-3xl mx-auto space-y-4 sm:space-y-5">
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center w-10 h-10 sm:w-11 sm:h-11 rounded-xl bg-[#5932EA]/10 text-[#5932EA] shrink-0">
          <HiOutlineGlobeAlt className="w-5 h-5 sm:w-6 sm:h-6" strokeWidth={2} />
        </div>
        <div className="min-w-0">
          <h1 className="text-xl sm:text-2xl font-semibold text-gray-800 dark:text-gray-100 tracking-tight truncate">
            {t("songImporter") || "Song Importer"}
          </h1>
          <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400 truncate">
            {t("songImporterPageSubtitle") ||
              "Search Cifra Club and import chords into your library"}
          </p>
        </div>
      </div>

      <div className="flex gap-2 overflow-x-auto scrollbar-none -mx-1 px-1 pb-0.5">
        <div className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium border border-gray-200/80 dark:border-gray-600/80 bg-white/70 dark:bg-gray-800/50 text-gray-600 dark:text-gray-300 shrink-0">
          <HiOutlineDocumentText className="w-3.5 h-3.5 text-[#5932EA]" />
          {t("importOriginal") || "Original"}
        </div>
        <div className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium border border-amber-200/70 dark:border-amber-800/40 bg-amber-50/80 dark:bg-amber-900/20 text-amber-800 dark:text-amber-200 shrink-0">
          <HiOutlineSparkles className="w-3.5 h-3.5" />
          {t("importSimplified") || "Simplified"}
        </div>
      </div>

      <section className="rounded-2xl border border-gray-200/70 dark:border-gray-700/70 bg-white/70 dark:bg-gray-800/50 backdrop-blur-sm p-3.5 sm:p-5">
        <CifraImportPanel
          hideLegend
          onImportReady={(prefill, notice) => {
            setImportError(notice || "");
            setAddPrefill(prefill);
            setShowAddModal(true);
          }}
        />
      </section>

      {showAddModal && addPrefill && (
        <AddSongModal
          importNotice={importError || undefined}
          onClose={() => {
            setShowAddModal(false);
            setAddPrefill(null);
            setImportError("");
          }}
          onSongAdded={() => {}}
          prefillData={addPrefill}
        />
      )}
    </div>
  );
};

export default Cifra;
